<form [formGroup]="formGroup">
  <sc-title>
    <sc-dictionary-label
      dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.detach-truck"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex>
    <sc-string-field formControlName="trailerNumberPlate"
      labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerNumberPlate"
      grow></sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field formControlName="swapTrailerNumber"
      labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"
      grow></sc-string-field>
  </sc-flex>
</form>
